
import { userListAPI } from '@/api/common';

import WkSelectDropdown from './src/SelectDropdown.vue';
import WkUser from './src/WkUser.vue';

import Emitter from 'element-ui/lib/mixins/emitter';
import { valueEquals } from 'element-ui/lib/utils/util';
import { objDeepCopy } from '@/utils';
import { isEmpty } from '@/utils/types';

export default {
  name: 'WkUserSelect',

  components: {
    WkSelectDropdown: WkSelectDropdown,
    WkUser: WkUser
  },

  mixins: [Emitter],

  props: {
    radio: Boolean,
    // 展示限制 0 标示展示全部
    max: {
      type: Number,
      default: 2
    },
    // 取值字段 如果继续新增 改为 props 方案
    props: {
      type: Object,
      default: function _default() {
        return {
          value: 'id',
          label: 'realname'
        };
      }
    },
    // 选择限制
    limit: Number,
    placeholder: {
      type: String,
      default: function _default() {
        return '请选择';
      }
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    },
    // 自定义请求和 参数
    request: Function,
    params: Object,
    options: Array,
    disabled: {
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      visible: false,
      dataValue: [], // 校准传入值
      loading: false,
      height: 34,

      optionsList: []
    };
  },


  computed: {
    // 实际展示的数据
    showSelects: function showSelects() {
      if (this.max && this.max > 0 && this.selects && this.selects.length > this.max) {
        return this.selects.slice(0, this.max);
      }
      return this.selects;
    },


    // 选择的数据
    selects: function selects() {
      var _this = this;

      if (!this.optionsList.length) {
        return [];
      }

      return this.optionsList.filter(function (item) {
        return _this.dataValue.includes(item[_this.props.value]);
      });
    }
  },

  watch: {
    visible: function visible(val) {
      if (!val) {
        this.broadcast('WkSelectDropdown', 'destroyPopper');
      } else {
        this.broadcast('WkSelectDropdown', 'updatePopper');
      }
      this.$emit('visible-change', val);
    },
    value: function value() {
      this.verifyValue();
    },


    options: {
      handler: function handler() {
        this.verifyOptions();
      },

      immediate: true
    },

    /**
     * 更新值
     */
    dataValue: function dataValue() {
      if (this.radio) {
        this.$emit('input', this.dataValue && this.dataValue.length ? this.dataValue[0] : '');
      } else {
        this.$emit('input', this.dataValue);
      }
    },


    showSelects: {
      handler: function handler() {
        this.resetHeight();
      },

      immediate: true
    }
  },

  created: function created() {
    this.verifyValue();
  },


  methods: {
    resetHeight: function resetHeight() {
      var _this2 = this;

      var tags = this.$refs.tags;
      if (tags) {
        this.$nextTick(function () {
          _this2.height = tags.clientHeight > 34 ? tags.clientHeight + 6 : 34;
        });
      } else {
        this.height = 34;
      }
    },


    /**
     * 处理值逻辑
     */
    verifyValue: function verifyValue() {
      var _this3 = this;

      // 多选的默认值 校准为数组  单选校准为number
      if (!this.radio && !Array.isArray(this.value)) {
        this.$emit('input', []);
      }

      if (this.radio && (Array.isArray(this.value) || this.value === null || this.value === undefined)) {
        this.$emit('input', '');
      }

      if (this.radio) {
        if (this.value !== this.dataValue) {
          if (!isEmpty(this.value)) {
            this.dataValue = [parseInt(this.value)];
          } else {
            this.dataValue = [];
          }
        }
      } else {
        if (!valueEquals(this.value, this.dataValue)) {
          if (this.value && this.value.length) {
            var firstItem = this.value[0];
            if (firstItem[this.props.value]) {
              this.dataValue = this.value.map(function (item) {
                return item[_this3.props.value];
              });
            } else {
              this.dataValue = objDeepCopy(this.value);
            }
          } else {
            this.dataValue = [];
          }
        }
      }
    },


    /**
     * 处理options
     */
    verifyOptions: function verifyOptions() {
      if (!this.options) {
        this.requestUserList();
      } else {
        this.optionsList = this.options;
      }
    },


    /**
     * 获取请求
     */
    requestUserList: function requestUserList() {
      var _this4 = this;

      this.loading = true;
      var request = userListAPI;
      var params = { pageType: 0 };
      if (this.request) {
        params = {};
        request = this.request;
      } else if (this.props.request) {
        request = this.props.request;
      }

      if (this.params) {
        params = this.params;
      }

      request(params).then(function (res) {
        _this4.optionsList = res.data.hasOwnProperty('list') ? res.data.list || [] : res.data || [];
        _this4.loading = false;
      }).catch(function () {
        _this4.loading = false;
      });
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    handleMenuEnter: function handleMenuEnter() {
      // 处理聚焦到具体位置
    },
    doDestroy: function doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy();
    },


    /**
     * 删除
     */
    deleteuser: function deleteuser(item) {
      if (!item.disabled && !this.disabled) {
        for (var index = 0; index < this.dataValue.length; index++) {
          var id = this.dataValue[index];
          if (id == item[this.props.value]) {
            this.dataValue.splice(index, 1);
            // this.$emit('change', this.dataValue, this.selects)
            this.wkUserChange();
            break;
          }
        }
      }
    },


    /**
     * 聚焦动作
     */
    focusClick: function focusClick() {
      this.$emit('focus');
    },


    /**
     * chang 事件
     */
    wkUserChange: function wkUserChange() {
      var _this5 = this;

      this.$nextTick(function () {
        if (_this5.radio) {
          _this5.dispatch('ElFormItem', 'el.form.change', _this5.dataValue && _this5.dataValue.length ? _this5.dataValue[0] : '');
        } else {
          _this5.dispatch('ElFormItem', 'el.form.change', _this5.dataValue);
        }
      });
      this.$emit('change', this.dataValue, this.selects);
    },
    containerClick: function containerClick() {
      if (!this.disabled) {
        this.visible = true;
      }
    }
  }
};